import React, { FC, memo, useState } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import { CheckInIcon, CheckOutIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import Markdown from '@components/utils/Markdown';
import { ReadMoreSection } from '@components/cards/summaries/hotel/SummaryCard';

import {
  StyledBoxItemContent,
  StyledBoxItemLabel,
  StyledBoxItemText,
  StyledBoxItem,
  StyledBody,
  StyledBoxFooter,
  StyledBoxFooterContent,
  StyledBoxFooterItem,
  StyledBoxFooterTitle,
  StyledBoxFooterDesc,
  Section,
} from './RulesStyle';

export interface RulesProps {
  checkinBeginTime?: string;
  checkinEndTime?: string;
  optionalFee?: string;
  checkoutTime?: string;
  mandatoryFee?: string;
  all?: string;
}

const LIMIT = 200;

const RulesBody: FC<RulesProps> = ({
  mandatoryFee = '',
  optionalFee = '',
  checkinEndTime = '',
  checkinBeginTime = '',
  checkoutTime = '',
}) => {
  const { xl } = useBreakpoint();

  const [isReadMore, setisReadMore] = useState<boolean>();
  const onReadMore = () => {
    setisReadMore(!isReadMore);
  };

  return (
    <div>
      <StyledBody>
        <StyledBoxItem>
          <CustomIcon
            icon={CheckInIcon}
            width={xl ? 56 : 37}
            height={xl ? 64 : 46}
          />
          <StyledBoxItemContent>
            <StyledBoxItemLabel>Giriş (Check-in)</StyledBoxItemLabel>
            <StyledBoxItemText>
              {checkinBeginTime} {checkinEndTime ? ` - ${checkinEndTime}` : ''}
            </StyledBoxItemText>
          </StyledBoxItemContent>
        </StyledBoxItem>

        {checkoutTime ? (
          <StyledBoxItem>
            <CustomIcon
              icon={CheckOutIcon}
              width={xl ? 56 : 37}
              height={xl ? 64 : 46}
            />
            <StyledBoxItemContent>
              <StyledBoxItemLabel>Çıkış (Check-out)</StyledBoxItemLabel>
              <StyledBoxItemText>{checkoutTime}</StyledBoxItemText>
            </StyledBoxItemContent>
          </StyledBoxItem>
        ) : null}
      </StyledBody>

      <StyledBoxFooter>
        <StyledBoxFooterContent>
          <StyledBoxFooterItem>
            <StyledBoxFooterTitle>Zorunlu Ücretler</StyledBoxFooterTitle>
            <StyledBoxFooterDesc>
              <Markdown text={mandatoryFee} />
            </StyledBoxFooterDesc>
          </StyledBoxFooterItem>

          <StyledBoxFooterItem>
            <StyledBoxFooterTitle>Opsiyonel Ücretler</StyledBoxFooterTitle>
            <StyledBoxFooterDesc>
              <Markdown
                text={isReadMore ? optionalFee : optionalFee.substr(0, LIMIT)}
              />
              {optionalFee.length > LIMIT ? (
                <Section>
                  <ReadMoreSection
                    text={!isReadMore ? 'Devamını Oku' : 'Daha az göster'}
                    onClick={onReadMore}
                  />
                </Section>
              ) : null}
            </StyledBoxFooterDesc>
          </StyledBoxFooterItem>
        </StyledBoxFooterContent>
      </StyledBoxFooter>
    </div>
  );
};

export default memo(RulesBody);
